// components/alert/index
// вспомогателный элемент lert

import template from './template.jade'
import style    from './style.scss'

var name = 'alert-dialog'

var empty = {
  get server() { return { wait:  false, error: false, } },
  get client() { return { parse: false, error: false, } },
  get form() { return { error: false, } },
}

export default {

  name: name,
  props: [
    {
      name: 'name',
      default: 'default',
    },
    'message',
  ],
  template: template({style: style}),

  data: () => ({
    server: { wait:  false, error: false, },
    client: { parse: false, error: false, },
    form: {error:false},
  }),

  events: {
    'alert': function (data) {
      // если нет имени алерта, то дефолтный
      // или елсли не совпадает то не применяем к алерту data
      if (this.name != data.name) {
        //window.debug && console.log(this.name, '!=', data.name)
        return true;
      }
     // window.debug && console.log(`alert.${this.name}:${data.type}:${data.view}`)
      this.$set('server', empty.server)
      this.$set('client', empty.client)
      this.$set('form', empty.form)
      this.$nextTick( () => this.$set(data.type, data.view) )
      return true;
    },
  },

  computed: {
    show: function () {
      return (
        this.server.wait ||
        this.server.error ||
        this.client.parse ||
        this.client.error ||
        this.form.error
      )
    }
  },

  methods: {
    // спрячем алерт
    hide() {
        this.server.wait =  this.server.error =
        this.client.parse = this.client.error = this.form.error = false
    },
  },
}



/** WEBPACK FOOTER **
 ** ./src/js/components/alert-dialog/index.js
 **/